import { tss } from 'tss-react/mui';

import type { AccordionProps } from '@mui/material';
import { Accordion } from '@mui/material';

const useStyles = tss.create(({ theme }) => {
  return {
    root: {
      '&:before': {
        height: '0px',
      },
      borderRadius: '20px',
      boxShadow: theme.boxShadow,
    },
    rounded: {
      '&:last-child, &:first-child': {
        borderRadius: '20px',
      },
    },
    onBottom: {
      border: `1px solid ${theme.cardBorder}`,
    },
    expandedOnTop: {
      backgroundColor: theme.darkCard,
    },
    onTop: {
      '&:hover': {
        backgroundColor: theme.darkCard,
      },
      boxShadow: 'none',
    },
  };
});

export interface Or2AccordionProps extends AccordionProps {
  onTop?: boolean;
  whiteWhenDisabled?: boolean;
  unmountOnExit?: boolean;
}

export const Or2Accordion = ({
  children,
  className,
  onTop = false,
  whiteWhenDisabled = false,
  unmountOnExit,
  ...other
}: Or2AccordionProps) => {
  const { classes, cx } = useStyles();

  const conditionalStyling = whiteWhenDisabled
    ? {
        '&.Mui-disabled': {
          backgroundColor: 'white',
        },
      }
    : null;

  return (
    <Accordion
      className={cx(className, {
        [classes.onTop]: onTop,
        [classes.onBottom]: !onTop,
      })}
      classes={{
        root: classes.root,
        rounded: classes.rounded,
        expanded: onTop ? classes.expandedOnTop : undefined,
      }}
      sx={conditionalStyling}
      slotProps={{ transition: { unmountOnExit } }}
      {...other}
    >
      {children}
    </Accordion>
  );
};
